import { render, staticRenderFns } from "./StatementAccount.vue?vue&type=template&id=59d8ab02&scoped=true"
import script from "./StatementAccount.vue?vue&type=script&lang=js"
export * from "./StatementAccount.vue?vue&type=script&lang=js"
import style0 from "./StatementAccount.vue?vue&type=style&index=0&id=59d8ab02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d8ab02",
  null
  
)

export default component.exports